export var getProductSearchQuery = function getProductSearchQuery(componentConfig) {
  var _ref = componentConfig.config || {},
      tags = _ref.tags,
      merchantList = _ref.merchantList,
      brandList = _ref.brandList,
      discountRange = _ref.discountRange,
      priceList = _ref.priceList,
      categoryIds = _ref.categoryIds,
      excludedBrands = _ref.excludedBrands,
      excludedCategories = _ref.excludedCategories,
      labels = _ref.labels,
      excludedTags = _ref.excludedTags,
      sortType = _ref.sortType,
      promoId = _ref.promoId,
      q = _ref.q,
      excludeLabels = _ref.excludeLabels;

  return {
    id: componentConfig.id,
    tg: tags || [],
    ntg: excludedTags || [],
    m: merchantList,
    b: brandList,
    dr: discountRange ? (10 - discountRange[1]) * 10 + "-" + (10 - discountRange[0]) * 10 : null,
    prs: priceList ? priceList[0] * 100 + "-" + priceList[1] * 100 : null,
    cids: categoryIds,
    nb: excludedBrands,
    ncids: excludedCategories,
    l2: labels,
    f: 0,
    t: componentConfig.config.maxProductNum || 20,
    s: sortType || 'sales',
    promoId: promoId,
    q: q,
    nl: excludeLabels
  };
};